import {Component, Input, OnInit} from '@angular/core';
import {AppealService} from '../../_service/appeal.service';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.css']
})
export class FileComponent implements OnInit {

  @Input() file;
  constructor() { }

  ngOnInit() {
  }

  async getFile(file){
    console.debug('Opening file:', file);
    window.open(file.path, '_blank');
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/file/file.component.ts